<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('user.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('user.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-12 col-md-5">
            <ts-button color="info" outline @click="addNew()">{{
              $t('add_new')
            }}</ts-button>
          </div>
          <div class="col-md-5">
            <a-radio-group
              v-model="user_type"
              @change="onChangeUserType"
              class="ts-w-1/3"
            >
              <a-radio-button :value="1" class="ts-w-1/2 ts-text-center">
                Staff
              </a-radio-button>
              <a-radio-button :value="2" class="ts-w-1/2 ts-text-center">
                Customer
              </a-radio-button>
            </a-radio-group>
          </div>
          <div class="col-sm-12 col-md-2 d-flex justify-content-end">
            <ts-input v-model="search" :placeholder="$t('search')" />
          </div>
        </div>
      </ts-card-wrapper>
      <staff v-if="user_type == 1" />
      <customer v-if="user_type == 2" ref="customer" />
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import staff from './index-staff.vue'
import customer from './index-customer.vue'

export default {
  name: 'userIndex',
  components: {
    staff,
    customer
  },
  data() {
    return {
      numeric: 1,
      visible_resetpwd: false,
      loading: false,
      errors: new Errors(),
      waiting: false,
      user_type: 1
    }
  },
  computed: {
    ...mapState('security/user', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.security.user.search
      },
      set(newValue) {
        this.$store.commit('security/user/SET_SEARCH', newValue)
        this.$store.commit('security/user/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    onChangeUserType(e) {
      // console.log(e)
    },
    addNew() {
      if (this.user_type == 1) {
        this.$router.push({ name: 'user-create' })
      } else if (this.user_type == 2) {
        this.$refs.customer.addNew()
      }
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('security/user/RESET_STATE')
    next()
  }
}
</script>
